import React from 'react';
import * as LucideIcons from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface IconButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon: keyof typeof LucideIcons;
  size?: number;
  ariaLabel: string;
}

export function IconButton({ icon, size = 18, ariaLabel, className = '', ...props }: IconButtonProps) {
  const Icon = (LucideIcons[icon] || LucideIcons.HelpCircle) as LucideIcon;
  return (
    <button {...props} className={`iconbtn ${className}`} aria-label={ariaLabel} type="button">
      <Icon size={size} strokeWidth={2.2} />
    </button>
  );
}
